import create from 'zustand'

export const userStore = create((set) => ({
    isLogin: false,
    login: () => set(state => ({ isLogin: true})),
    logout: () => set(state => ({ isLogin: false}))
}))